<template>
  <div>
    <Sec v-if="cate" />
    <Literature v-else />
  </div>
</template>

<script>
import Literature from './literature'
import Sec from './sec'
export default {
  components: {
    Literature,
    Sec
  },
  data() {
    return {
      cate: ''
    }
  },
  created() {
    const { cate } = this.$route.query
    this.cate = cate
  },
  methods: {
  }
}
</script>